import { Link } from 'react-router-dom';
import { works } from '@/mocks/works';

const entries = [
  {
    type: 'movie',
    title: '电影',
    desc: '院线新片 · 口碑佳作 · 经典重映',
    icon: 'ri-film-line',
  },
  {
    type: 'tv',
    title: '电视剧',
    desc: '热播剧集 · 高分神作 · 多元题材',
    icon: 'ri-tv-2-line',
  },
];

export default function CategoryEntries() {
  return (
    <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 md:gap-6">
      {entries.map((entry) => {
        const count = works.filter((w) => w.type === entry.type).length;
        return (
          <Link
            key={entry.type}
            to={`/category/${entry.type}`}
            className="group flex items-center gap-5 rounded-lg border border-background-200 bg-background-50 p-5 transition-colors hover:border-primary-300 md:p-6"
          >
            <span className="flex h-14 w-14 shrink-0 items-center justify-center rounded-lg bg-primary-900 text-accent-400 md:h-16 md:w-16">
              <i className={`${entry.icon} text-3xl`} />
            </span>
            <div className="min-w-0 flex-1">
              <div className="flex items-center gap-2">
                <h3 className="font-heading text-lg font-bold text-foreground-950 md:text-xl">{entry.title}</h3>
                <span className="rounded-full bg-secondary-100 px-2 py-0.5 text-xs text-secondary-900">
                  {count} 部
                </span>
              </div>
              <p className="mt-1 text-sm text-foreground-600">{entry.desc}</p>
            </div>
            <i className="ri-arrow-right-line text-xl text-foreground-400 transition-transform group-hover:translate-x-1 group-hover:text-accent-600" />
          </Link>
        );
      })}
    </div>
  );
}